import classNames from 'classnames/bind';
import React, { useState } from 'react';
import { useDispatch, useStore } from 'react-redux';

import styles from './MissionList.module.scss';

import actions from '@/actions';
import MissionPreview from '@/components/ui/MissionPreview';
import MissionTable from '@/components/ui/MissionTable';
import ModalWrapper from '@/components/ui/ModalWrapper';
import { getCommandForSurveySegment } from '@/helpers/CommandConverter';
import { ModalService as modal } from '@/libs/Modal';
import { NotifierService as notifier } from '@/libs/Notifier';
import { deepCopy } from '@/utils/ObjectUtils';

const cx = classNames.bind(styles);

export const PURPOSE = {
  GUIDE: Symbol('GUIDE'),
  UPLOAD: Symbol('UPLOAD'),
};

const Modal = ({ purpose }) => {
  const dispatch = useDispatch();
  const store = useStore();
  const [selectedMission, setSelectedMission] = useState();

  const handleSelect = (mission) => {
    // 미션 선택 해제된 경우 (예: 미션 삭제)
    if (!mission) {
      setSelectedMission(null);
      return;
    }

    const nextSelectedMission = deepCopy(mission);
    nextSelectedMission.json.commands = mission.json.commands.map((command) => getCommandForSurveySegment(command));
    setSelectedMission(nextSelectedMission);
  };

  const close = () => {
    modal.hide();
  };

  const doLoad = () => {
    if (!selectedMission) {
      notifier.error('No item selected.');
      return;
    }

    // 가이드용
    if (purpose === PURPOSE.GUIDE) {
      const isAdded = store.getState().missions.some(({ id }) => id === selectedMission.id);
      if (isAdded) {
        notifier.error('This mission is already added.');
        return;
      }

      dispatch(actions.missions.add(selectedMission));
    }
    // 업로드용
    else if (purpose === PURPOSE.UPLOAD) {
      const commands = [];
      selectedMission.json.commands.forEach((command) => {
        switch (command.type) {
          case 'navWaypoint':
            commands.push(command);

            // 촬영 명령 위치인 경우
            if (Object.hasOwn(command.data, 'camera')) {
              // 촬영 시작점 여부
              const isStartToShoot = command.data.camera.shoot;
              const id = `${command.id}/camera/` + (isStartToShoot ? 'start' : 'stop');
              const distance = command.data.camera.interval;

              commands.push({ id, type: 'doSetCamTriggDist', data: { distance } });
            }
            break;

          case 'cusSurvey':
            command.data.positions.forEach((position, index) => {
              commands.push({
                id: `${command.id}/${index}`,
                type: 'navWaypoint',
                data: {
                  position: { lat: position.lat, lng: position.lng },
                  altitude: command.data.altitude,
                },
              });

              // 촬영 명령 위치인 경우
              if (Object.hasOwn(position, 'shoot')) {
                // 촬영 시작점 여부
                const isStartToShoot = position.shoot;
                const id = `${command.id}/${index}/camera/` + (isStartToShoot ? 'start' : 'stop');
                const distance = isStartToShoot ? command.data.camera.interval : 0;

                commands.push({ id, type: 'doSetCamTriggDist', data: { distance } });
              }
            });
            break;

          default:
            commands.push(command);
            break;
        }
      });

      store.getState().robot.targetRobotIds.forEach((robotId) => {
        dispatch(
          actions.missions.load(robotId, { id: selectedMission.id, commands, fences: selectedMission.json.fences })
        );
      });
    }

    close();
  };

  return (
    <ModalWrapper className={cx('container')}>
      <div className={cx('wrapper')}>
        <MissionTable onSelect={handleSelect} showEdit={purpose === PURPOSE.UPLOAD} showDelete />
        <MissionPreview mission={selectedMission} />
      </div>
      <div className={cx('bottom')}>
        <button type="button" className={cx('button')} onClick={close}>
          Cancel
        </button>
        <button type="button" className={cx(['button', 'accent'])} onClick={doLoad}>
          Load
        </button>
      </div>
    </ModalWrapper>
  );
};

export default Modal;
